import {SensitivityParams} from "./sensitivity-params";
import {SensitivityReturnSummary} from "./sensitivity-return-summary";
import {AggregatedFundCashflows} from "./aggregated-fund-cashflows";

export interface FundValuationSensitivity {
    id?: number;
    fundValuationRevId?: number;
    name?: string;
    createdByName?: string;
    custom?: boolean;
    sensitivityParams?: SensitivityParams;
    sensitivityReturnSummary?: SensitivityReturnSummary;
    aggregatedFundCashflowsLow?: AggregatedFundCashflows;
    aggregatedFundCashflowsBase?: AggregatedFundCashflows;
    aggregatedFundCashflowsHigh?: AggregatedFundCashflows;
    aggregatedFundCashflowsWeighted?: AggregatedFundCashflows;
    clientErrorMessage?: string;
    errorCode?: string;
}

export const EMTPY_FUND_VALUATION_SENSITIVITY: FundValuationSensitivity = {
    id: undefined,
    fundValuationRevId: undefined,
    name: undefined,
    createdByName: undefined,
    custom: undefined,
    sensitivityParams: undefined,
    sensitivityReturnSummary: undefined,
    aggregatedFundCashflowsLow: undefined,
    aggregatedFundCashflowsBase: undefined,
    aggregatedFundCashflowsHigh: undefined,
    aggregatedFundCashflowsWeighted: undefined,
    clientErrorMessage: undefined,
    errorCode: undefined
}
